const MONTH_PATTERN = /^(\d{4})-(\d{2})$/;
const MAX_CALENDAR_EMPLOYEE_IDS = 2000;
const CALENDAR_ROUTE_NAMES = {
  leaves: 'ViewLeavesCalendarFiltered',
  covers: 'ViewCoverCalendarFiltered'
};

const parseEmployeeIds = value => {
  if (value === 'all') return { employeeIds: [], error: null };
  if (typeof value !== 'string' || value === '') {
    return { employeeIds: [], error: 'Employee IDs are required.' };
  }

  const segments = value.split(',');
  if (segments.some(segment => !/^\d+$/.test(segment))) {
    return { employeeIds: [], error: 'Employee IDs must be positive integers separated by commas.' };
  }

  const employeeIds = Array.from(new Set(segments.map(Number)))
    .sort((firstId, secondId) => firstId - secondId);
  if (employeeIds.some(employeeId => !Number.isSafeInteger(employeeId) || employeeId <= 0)) {
    return { employeeIds: [], error: 'One or more employee IDs are invalid.' };
  }
  if (employeeIds.length > MAX_CALENDAR_EMPLOYEE_IDS) {
    return {
      employeeIds: [],
      error: `A maximum of ${MAX_CALENDAR_EMPLOYEE_IDS} employee IDs is allowed.`
    };
  }
  return { employeeIds, error: null };
};

export const parseCalendarRouteFilters = params => {
  const employees = parseEmployeeIds(params.employeeIds);
  if (employees.error) return { valid: false, error: employees.error, employeeIds: [] };

  const monthValue = typeof params.month === 'string' ? params.month : '';
  const match = monthValue.match(MONTH_PATTERN);
  if (!match) {
    return { valid: false, error: 'Month must use YYYY-MM format.', employeeIds: [] };
  }

  const year = Number(match[1]);
  const monthNumber = Number(match[2]);
  if (year < 1970 || year > 9999 || monthNumber < 1 || monthNumber > 12) {
    return { valid: false, error: 'The calendar month is invalid.', employeeIds: [] };
  }

  return {
    valid: true,
    error: null,
    employeeIds: employees.employeeIds,
    month: monthValue,
    initialDate: `${monthValue}-01`
  };
};

export const buildCalendarRoute = ({ calendarType = 'leaves', employeeIds = [], month }) => ({
  name: CALENDAR_ROUTE_NAMES[calendarType] || CALENDAR_ROUTE_NAMES.leaves,
  params: {
    employeeIds: employeeIds.length
      ? Array.from(new Set(employeeIds)).sort((firstId, secondId) => firstId - secondId).join(',')
      : 'all',
    month
  }
});

export const getLondonCurrentMonth = () => {
  const parts = new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/London',
    year: 'numeric',
    month: '2-digit'
  }).formatToParts(new Date());
  const value = type => parts.find(part => part.type === type)?.value;
  return `${value('year')}-${value('month')}`;
};

export const buildDefaultCalendarRoute = (calendarType = 'leaves') => buildCalendarRoute({
  calendarType,
  employeeIds: [],
  month: getLondonCurrentMonth()
});
